var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.sourceForm !== _vm.SOURCEFORM_TMBD && !_vm.isMPSdtj
    ? _c(
        "header",
        { class: [_vm.noBottomLine ? "header-no-bottom-line" : ""] },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showHome && !_vm.showBack,
                  expression: "showHome && !showBack",
                },
              ],
              staticClass: "left",
              on: { click: _vm.onHomeClick },
            },
            [_c("icon", [_vm._v("tab_shouye")])],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBack,
                  expression: "showBack",
                },
              ],
              staticClass: "left",
              on: { click: _vm.goBack },
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../image/global/iconLeftBack@3x.png"),
                  width: "11px",
                  height: "19px",
                  alt: "",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { class: ["title", _vm.custonmClass] },
            [
              _vm._t("title", function () {
                return [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.titleProps || _vm.routerTitle) +
                      "\n    "
                  ),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [_vm._t("right")], 2),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }